export const ROLES = {
    COACH: 'coach',
    COACH_ASSISTANT: 'coach-assistant',
    BAKELISTE: 'bakeliste'
};

export const ACTIONS = {
    POSTULER: 'POSTULER',
    ASSIGNER: 'ASSIGNER',
    MODIFIER_DATES: 'MODIFIER_DATES',
    VALIDER: 'VALIDER',
    REJETER: 'REJETER',
    CHANGER_IMAGE: 'CHANGER_IMAGE'
};

export const PERMISSIONS = {
    [ROLES.COACH]: [
        ACTIONS.ASSIGNER,
        ACTIONS.MODIFIER_DATES,
        ACTIONS.VALIDER,
        ACTIONS.REJETER,
        ACTIONS.CHANGER_IMAGE
    ],
    [ROLES.COACH_ASSISTANT]: [
        ACTIONS.ASSIGNER,
        ACTIONS.MODIFIER_DATES,
        ACTIONS.VALIDER,
        ACTIONS.REJETER,
        ACTIONS.CHANGER_IMAGE
    ],
    [ROLES.BAKELISTE]: [
        ACTIONS.POSTULER
    ]
};

export const hasPermission = (user, action, task = null) => {
    if (!user?.statut) return false;

    // Vérifie si l'utilisateur a le rôle nécessaire
    const userHasRole = PERMISSIONS[user.statut]?.includes(action);

    // Vérifie les conditions spécifiques pour certaines actions
    switch (action) {
        case ACTIONS.POSTULER:
            return userHasRole &&
                !task?.assigned_to_id &&
                !task?.postulants?.some(postulant => postulant.id === user.id);

        case ACTIONS.ASSIGNER:
        case ACTIONS.MODIFIER_DATES:
        case ACTIONS.VALIDER:
        case ACTIONS.REJETER:
        case ACTIONS.CHANGER_IMAGE:
            return userHasRole;

        default:
            return false;
    }
};

export const getAvailableActions = (user, task) => {
    if (!user?.statut) return [];

    return PERMISSIONS[user.statut]?.filter(action =>
        hasPermission(user, action, task)
    ) || [];
}; 